import { render, staticRenderFns } from "./driverWallet.vue?vue&type=template&id=774aed21&scoped=true&"
import script from "./driverWallet.vue?vue&type=script&lang=js&"
export * from "./driverWallet.vue?vue&type=script&lang=js&"
import style0 from "./driverWallet.vue?vue&type=style&index=0&id=774aed21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774aed21",
  null
  
)

export default component.exports